export class ProductError {
  type: ProductErrorType;
  property: string;
  // each error type in each product has a different payload
  // must contain contextualized info (slugs, name, index, ...)
  payload?: any;

  static validatePrimitiveTypes(
    obj: any,
    requiredPropertiesName: string[],
    limits?: { property: string; length: number }[],
    parentPath = '',
  ): ProductError[] {
    const errors: ProductError[] = requiredPropertiesName
      .filter(property => obj[property] !== false && !obj[property])
      .map(property => ({ type: ProductErrorType.MISSING, property: parentPath + property }));
    if (limits) {
      requiredPropertiesName
        .filter(property => {
          const limit = limits.find(l => l.property === property);
          if (limit) {
            if (obj[property]) {
              const propertyPlainText = new DOMParser().parseFromString(obj[property], 'text/html').body.textContent;
              return limit.length < propertyPlainText.split(' ').length;
            }
          }
        })
        .forEach(property => errors.push({ type: ProductErrorType.BAD_FORMAT, property: parentPath + property }));
    }
    return errors;
  }
}

export enum ProductErrorType {
  MISSING = 'missing',
  CANNOT_BE_NULL = 'cannot-be-null',
  BAD_FORMAT = 'bad-format',
  NOT_ENOUGH_VALUE = 'not-enough-value',
  TOO_MUCH_VALUES = 'too-much-values',
  OUT_OF_RANGE = 'out-of-range',
}

export interface ImportError {
  line: number;
  column: string;
  value: string;
}

export interface ImportErrorMessage {
  key: string;
  type: string;
  params: {
    value: string;
    line: string;
    column: string;
  };
}

export interface ImportErrorTableRow {
  column: string;
  line: string;
  type: string;
  value: string;
  message: string;
}
